<template>
    <!-- 보호소 공용 메모 (SHELTER_MEMO) — 포스트잇 더미. 메모 버튼(+)을 누르면 맨 아래에 새 포스트잇이 붙고 바로 입력
         고정은 맨 위, 나머지는 아래로 갈수록 최신. 바뀐 내용이 있으면 오른쪽 아래 [저장] (자동 저장 없음)
         공고·입양신청서 연결은 포스트잇의 [공고 연결]·[신청서 연결] 버튼에서 찾아서 고름 -->
    <!-- 접혔을 때: '메모 n ⌃' 만 (누르면 펼치기) -->
    <div v-if="!open && $store.state.auth.status.loggedIn" class="smp smp-collapsed">
        <button type="button" class="smp-bar smp-bar-collapsed" title="메모 펼치기" @click="expand()">
            <span class="smp-bar-title"><i class="bi bi-sticky-fill"></i> 메모 <small v-if="saved.length">{{ saved.length }}</small></span>
            <span class="smp-bar-btn"><i class="bi bi-chevron-up"></i></span>
        </button>
    </div>
    <div v-else-if="open" class="smp" :class="{ active }" ref="panel" @keydown.esc="close()" @mousedown="active = true" @focusin="active = true">
        <div class="smp-bar">
            <span class="smp-bar-title"><i class="bi bi-sticky-fill"></i> 메모 <small v-if="saved.length">{{ saved.length }}</small></span>
            <select v-if="$root.isAdmin" class="form-select form-select-sm smp-shelter" v-model="adminShelter" @change="load('top')">
                <option value="">보호소 선택</option>
                <option v-for="s in ($root.admin && $root.admin.shelterList) || []" :key="s.shelter_device_number" :value="s.shelter_device_number">{{ s.shelter_name }}</option>
            </select>
            <button type="button" class="smp-bar-btn" title="접기" @click="close()"><i class="bi bi-chevron-down"></i></button>
        </div>

        <div class="smp-stack" ref="stack">
            <p v-if="!shelter" class="smp-hint">메모를 볼 보호소를 선택해주세요.</p>
            <p v-else-if="loading && !notes.length" class="smp-hint">불러오는 중…</p>

            <div v-for="(n, i) in ordered" :key="n.key" class="pit"
                 :class="['c-' + n.color, { editing: editingKey == n.key, pinned: n.pinned == 'ON', fresh: n.key == flashKey, picking: pick.key == n.key }]"
                 :style="{ '--tilt': tilt(i) }" @click="startEdit(n)">
                <span v-if="n.pinned == 'ON'" class="pit-pin" title="고정됨"><i class="bi bi-pin-angle-fill"></i></span>

                <!-- 고정·색·삭제: 보기 상태에서만 (쓰는 중엔 서식 도구만) -->
                <div v-if="editingKey != n.key" class="pit-tools" @click.stop>
                    <button type="button" :title="n.pinned == 'ON' ? '고정 풀기' : '맨 위에 고정'" :class="{ on: n.pinned == 'ON' }" :disabled="!n.idx" @click="togglePin(n)"><i class="bi" :class="n.pinned == 'ON' ? 'bi-pin-angle-fill' : 'bi-pin-angle'"></i></button>
                    <button type="button" title="색 바꾸기" @click="nextColor(n)"><i class="bi bi-palette"></i></button>
                    <button type="button" title="삭제" @click="remove(n)"><i class="bi bi-trash3"></i></button>
                </div>
                <RichTextEditor v-if="editingKey == n.key" :ref="'ed' + n.key" v-model="n.draft" bare mini :minHeight="111" :maxHeight="320"
                                placeholder="메모를 입력하세요" @submit="save(n)"/>
                <div v-else class="rich-text pit-text" :class="{ empty: !n.content }" v-html="n.content ? sanitizeHtml(n.content) : '메모를 입력하세요'"></div>

                <div class="pit-foot" @click.stop>
                    <div class="pit-links">
                    <span v-if="n.notify_number" class="pit-chip" title="동물 보기" @click="goAnimal(n)"><i class="bi bi-tag"></i> {{ n.animal_name || n.notify_number }}<i class="bi bi-x pit-chip-x" title="연결 빼기" @click.stop="setLink(n, null)"></i></span>
                    <span v-if="n.request_idx" class="pit-chip" title="입양신청서 보기" @click="goRequest(n)"><i class="bi bi-file-earmark-text"></i> 신청서{{ n.applicant ? ' · ' + n.applicant : '' }}<i class="bi bi-x pit-chip-x" title="연결 빼기" @click.stop="setLink(n, null)"></i></span>
                    <template v-if="!n.notify_number && !n.request_idx">
                        <button type="button" class="pit-link-btn" @click="openPick(n, 'animal')"><i class="bi bi-link-45deg"></i> 공고 연결</button>
                        <button type="button" class="pit-link-btn" @click="openPick(n, 'request')"><i class="bi bi-link-45deg"></i> 신청서 연결</button>
                    </template>
                    </div>
                    <!-- 바뀐 내용이 있으면 날짜 자리에 [저장] -->
                    <button v-if="isDirty(n) || n.saving" type="button" class="pit-save" :disabled="n.saving" @click="save(n)">{{ n.saving ? '저장 중…' : '저장' }}</button>
                    <span v-else class="pit-date">{{ n.idx ? when(n) : '새 메모' }}</span>
                </div>

                <!-- 연결할 동물·신청서 고르기 -->
                <div v-if="pick.key == n.key" class="pit-pick" @click.stop>
                    <div class="pit-pick-tabs">
                        <button type="button" :class="{ on: pick.kind == 'animal' }" @click="setPickKind('animal')">공고</button>
                        <button type="button" :class="{ on: pick.kind == 'request' }" @click="setPickKind('request')">입양신청서</button>
                        <button type="button" class="pit-pick-x" title="닫기" @click="pick.key = null"><i class="bi bi-x-lg"></i></button>
                    </div>
                    <input ref="pickInput" class="form-control form-control-sm pit-pick-input" v-model="pick.q" @input="searchSoon()"
                           :placeholder="pick.kind == 'animal' ? '이름·공고번호·내부번호' : '신청자·공고번호·동물 이름'"/>
                    <div class="pit-pick-list">
                        <!-- 지금 보고 있는 상세 (바로 고르기) -->
                        <button v-if="pickCurrent" type="button" class="pit-pick-row now" @click="setLink(n, pickCurrent)">
                            <span class="pit-pick-main"><i class="bi bi-eye"></i> 지금 보는 {{ pick.kind == 'animal' ? '동물' : '신청서' }} · {{ pickCurrent.label }}</span>
                        </button>
                        <p v-if="pick.loading" class="pit-pick-empty">찾는 중…</p>
                        <p v-else-if="!pick.results.length" class="pit-pick-empty">{{ pick.q ? '찾는 결과가 없어요' : '검색어를 입력하세요' }}</p>
                        <button v-for="r in pick.results" :key="r.key" type="button" class="pit-pick-row" @click="setLink(n, r)">
                            <span class="pit-pick-main">{{ r.label }}</span>
                            <span class="pit-pick-sub">{{ r.sub }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RichTextEditor from '@/components/common/RichTextEditor.vue';
import { sanitizeHtml, isEmptyHtml, normalizeEditorHtml } from '@/utils/richText';
import { memoContext } from '@/utils/memoContext';

const COLORS = ['yellow', 'orange', 'green', 'blue', 'pink'];
let seq = 0;
const OPEN_KEY = 'shelterMemoOpen';

export default {
    name: 'ShelterMemoPanel',
    components: { RichTextEditor },
    data() {
        return {
            open: false,
            active: false,        //누르거나 쓰는 중이면 창(모달)보다 위로, 밖을 누르면 다시 아래로
            loading: false,
            notes: [],             //{ key, idx, content, draft, color, pinned, notify_number, request_idx, animal_name, applicant, reg_date, saving }
            editingKey: null,
            flashKey: null,
            adminShelter: '',
            pick: { key: null, kind: 'animal', q: '', results: [], loading: false, timer: null, seq: 0 },
        };
    },
    computed: {
        shelter() {
            if (this.$root.isAdmin) return this.adminShelter || null;
            return this.$root.shelter && this.$root.shelter.shelter_device_number;
        },
        saved() { return this.notes.filter(n => n.idx); },
        //고정 → 나머지(오래된 것 → 최신) → 아직 저장 안 된 새 메모 (맨 아래 = 버튼 바로 위)
        ordered() {
            const pinned = this.notes.filter(n => n.idx && n.pinned == 'ON');
            const rest = this.notes.filter(n => n.idx && n.pinned != 'ON').sort((a, b) => a.idx - b.idx);
            const fresh = this.notes.filter(n => !n.idx);
            return [...pinned, ...rest, ...fresh];
        },
        //고르기 목록 맨 위: 지금 열려 있는 동물 상세·신청서 상세
        pickCurrent() {
            if (this.pick.kind == 'animal' && memoContext.animal) {
                const a = memoContext.animal;
                return { kind: 'animal', notify_number: a.notify_number, animal_name: a.animal_name, label: (a.animal_name ? a.animal_name + ' · ' : '') + a.notify_number };
            }
            if (this.pick.kind == 'request' && memoContext.request) {
                const r = memoContext.request;
                return { kind: 'request', request_idx: r.idx, applicant: r.applicant, notify_number: r.notify_number, label: (r.applicant || '신청서') + (r.notify_number ? ' · ' + r.notify_number : '') };
            }
            return null;
        },
    },
    mounted() {
        this.emitter.on('openShelterMemo', this.onFab);
        document.addEventListener('mousedown', this.onOutside, true);
        //기본은 펼친 상태 (PC). 접으면 이 브라우저에 기억. 모바일은 화면을 가려서 기본 접힘
        let saved = null;
        try { saved = localStorage.getItem(OPEN_KEY); } catch (e) { /* 저장 불가 환경 */ }
        const mobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
        if (saved == '1' || (saved == null && !mobile)) {
            this.open = true;
            this.load('top');
        } else {
            this.load('none');   //접힌 바에 건수
        }
    },
    beforeUnmount() {
        this.emitter.off('openShelterMemo', this.onFab);
        document.removeEventListener('mousedown', this.onOutside, true);
        clearTimeout(this.pick.timer);
    },
    methods: {
        sanitizeHtml,
        tilt(i) { return [-1.2, 0.8, -0.5, 1.1, -0.9][i % 5] + 'deg'; },
        rememberOpen(v) {
            try { localStorage.setItem(OPEN_KEY, v ? '1' : '0'); } catch (e) { /* 저장 불가 환경 */ }
        },
        //메모 버튼(+): 접혀 있으면 펼치고, 맨 아래에 새 포스트잇
        onFab() {
            this.active = true;
            if (!this.open) {
                this.open = true;
                this.rememberOpen(true);
                this.load('none').then(() => this.addNote());
            } else {
                this.addNote();
            }
        },
        //접힌 바 누르기: 펼치기만 (새 메모는 + 버튼)
        expand() {
            this.open = true;
            this.rememberOpen(true);
            this.load('top');
        },
        //[접기] 버튼
        close() {
            if (this.editingKey) this.finishByKey(this.editingKey);
            this.pick.key = null;
            this.open = false;
            this.active = false;
            this.rememberOpen(false);
        },
        //포스트잇 밖을 누르면 쓰던 것만 내려놓음 (펼친 상태는 유지, 창보다 아래로)
        onOutside(e) {
            if (!this.open) return;
            const t = e.target;
            if (this.$refs.panel && this.$refs.panel.contains(t)) return;
            if (t.closest && (t.closest('.memo-fab') || t.closest('.ql-tooltip') || t.closest('.p-dialog'))) return;
            if (this.editingKey) this.finishByKey(this.editingKey);
            this.pick.key = null;
            this.active = false;
        },
        //scroll: 'top' = 맨 위부터(처음 펼칠 때) / 'end' = 맨 아래 / 'none'
        load(scroll) {
            if (!this.shelter) { this.notes = []; return Promise.resolve(); }
            this.loading = true;
            return this.axios.get('/shelter/memo?shelter_device_number=' + encodeURIComponent(this.shelter)).then(res => {
                const list = Array.isArray(res.data) ? res.data : [];
                //저장 안 한 내용은 유지 (쓰던 새 메모, 고치던 메모)
                const fresh = this.notes.filter(n => !n.idx && !isEmptyHtml(n.draft));
                const local = {};
                this.notes.filter(n => n.idx && this.isDirty(n)).forEach(n => { local[n.idx] = n; });
                this.notes = list.map(m => local[m.idx] || this.toNote(m)).concat(fresh);
                if (scroll == 'top') this.$nextTick(() => { const st = this.$refs.stack; if (st) st.scrollTop = 0; });
                else if (scroll == 'end') this.scrollEnd();
            }).catch(() => { this.notes = []; })
              .finally(() => { this.loading = false; });
        },
        toNote(m) {
            return { key: 'm' + m.idx, idx: m.idx, content: m.content || '', draft: m.content || '', color: m.color || 'yellow', pinned: m.pinned || 'OFF',
                notify_number: m.notify_number, request_idx: m.request_idx, animal_name: m.animal_name, applicant: m.applicant, reg_date: m.reg_date, mod_date: m.mod_date, saving: false };
        },
        addNote() {
            if (!this.shelter) return;
            //이미 비어 있는 새 메모가 있으면 그걸로
            let n = this.notes.find(x => !x.idx && isEmptyHtml(x.draft));
            if (!n) {
                n = { key: 'n' + (++seq), idx: null, content: '', draft: '', color: 'yellow', pinned: 'OFF', notify_number: null, request_idx: null, saving: false };
                this.notes.push(n);
            }
            this.startEdit(n);
            this.scrollEnd();
        },
        startEdit(n) {
            if (this.editingKey == n.key) return;
            if (this.editingKey) this.finishByKey(this.editingKey);
            this.editingKey = n.key;
            this.$nextTick(() => {
                const ed = this.$refs['ed' + n.key];
                const c = Array.isArray(ed) ? ed[0] : ed;
                c && c.focus();
            });
        },
        isDirty(n) {
            return normalizeEditorHtml(n.draft) != (n.content || '') || !!n.dirtyMeta;
        },
        //다른 포스트잇으로 옮기거나 접을 때: 저장하지 않음 (쓰던 내용은 남겨 두고 [저장] 표시), 빈 새 메모만 치움
        finishByKey(key) {
            const n = this.notes.find(x => x.key == key);
            this.editingKey = null;
            if (n && !n.idx && isEmptyHtml(n.draft) && this.pick.key != n.key) this.notes = this.notes.filter(x => x.key != n.key);
        },
        //저장: 새 메모는 POST, 있던 메모는 바뀐 경우만 PUT. 빈 새 메모는 그냥 지움
        save(n) {
            const html = normalizeEditorHtml(n.draft);
            if (!html) { alert(n.idx ? '내용을 다 지웠어요. 메모를 없애려면 휴지통을 눌러주세요.' : '메모 내용을 입력해주세요.'); return Promise.resolve(); }
            if (n.idx && html == n.content && !n.dirtyMeta) return Promise.resolve();
            if (n.saving) return Promise.resolve();
            n.saving = true;
            const body = { content: html, color: n.color, notify_number: n.notify_number || null, request_idx: n.request_idx || null };
            const req = n.idx
                ? this.axios.put('/shelter/memo/' + n.idx, body)
                : this.axios.post('/shelter/memo?shelter_device_number=' + encodeURIComponent(this.shelter), body);
            return req.then(res => {
                if (!res.data || res.data.result != 'YES') { alert((res.data && res.data.resultMsg) || '메모를 저장하지 못했습니다.'); return; }
                if (!n.idx) {
                    n.idx = Number(res.data.resultInfo);
                    n.reg_date = this.nowText();
                    this.flash(n);
                }
                n.content = html;
                n.dirtyMeta = false;
            }).catch(() => alert('메모 저장 중 오류가 발생했습니다.'))
              .finally(() => { n.saving = false; });
        },
        nextColor(n) {
            n.color = COLORS[(COLORS.indexOf(n.color) + 1) % COLORS.length];
            if (n.idx) n.dirtyMeta = true;
        },

        // ── 동물·신청서 연결 ──
        openPick(n, kind) {
            this.pick.key = n.key;
            this.pick.kind = kind || 'animal';
            this.pick.q = '';
            this.search();
            this.$nextTick(() => { const el = this.$refs.pickInput; const i = Array.isArray(el) ? el[0] : el; i && i.focus(); });
        },
        setPickKind(k) {
            this.pick.kind = k;
            this.search();
        },
        searchSoon() {
            clearTimeout(this.pick.timer);
            this.pick.timer = setTimeout(() => this.search(), 300);
        },
        search() {
            if (!this.shelter) return;
            const kind = this.pick.kind, q = (this.pick.q || '').trim();
            //동물은 검색어가 있어야 (보호소 동물이 많음), 신청서는 비우면 최근 것
            if (kind == 'animal' && !q) { this.pick.results = []; return; }
            const my = ++this.pick.seq;
            this.pick.loading = true;
            this.axios.get('/shelter/memo/targets?kind=' + kind + '&q=' + encodeURIComponent(q) + '&shelter_device_number=' + encodeURIComponent(this.shelter))
                .then(res => {
                    if (my != this.pick.seq) return;
                    const rows = Array.isArray(res.data) ? res.data : [];
                    this.pick.results = kind == 'animal'
                        ? rows.map(r => ({ key: 'a' + r.notify_number, kind, notify_number: r.notify_number, animal_name: r.animal_name,
                            label: (r.animal_name ? r.animal_name + ' · ' : '') + r.notify_number, sub: [r.management_number, r.state].filter(v => v).join(' · ') }))
                        : rows.map(r => ({ key: 'r' + r.idx, kind, request_idx: r.idx, applicant: r.applicant, notify_number: r.notify_number,
                            label: (r.applicant || '신청서') + ' · ' + (r.animal_name || r.notify_number), sub: [r.state, r.request_date].filter(v => v).join(' · ') }));
                })
                .catch(() => { if (my == this.pick.seq) this.pick.results = []; })
                .finally(() => { if (my == this.pick.seq) this.pick.loading = false; });
        },
        //target = null 이면 연결 빼기. 신청서를 고르면 그 동물도 같이 (서버가 채움)
        setLink(n, target) {
            n.notify_number = null; n.request_idx = null; n.animal_name = null; n.applicant = null;
            if (target && target.kind == 'animal') { n.notify_number = target.notify_number; n.animal_name = target.animal_name; }
            if (target && target.kind == 'request') { n.request_idx = target.request_idx; n.applicant = target.applicant; n.notify_number = target.notify_number || null; }
            this.pick.key = null;
            if (n.idx) n.dirtyMeta = true;
        },

        togglePin(n) {
            if (!n.idx) return;
            const v = n.pinned == 'ON' ? 'OFF' : 'ON', prev = n.pinned;
            n.pinned = v;
            this.axios.put('/shelter/memo/' + n.idx + '/pin', { pinned: v }).then(res => {
                if (!res.data || res.data.result != 'YES') { n.pinned = prev; alert((res.data && res.data.resultMsg) || '변경하지 못했습니다.'); }
            }).catch(() => { n.pinned = prev; alert('변경 중 오류가 발생했습니다.'); });
        },
        remove(n) {
            if (!n.idx) { this.notes = this.notes.filter(x => x.key != n.key); if (this.editingKey == n.key) this.editingKey = null; return; }
            if (!confirm('이 메모를 삭제할까요? 삭제하면 되돌릴 수 없어요.')) return;
            this.axios.delete('/shelter/memo/' + n.idx).then(res => {
                if (!res.data || res.data.result != 'YES') { alert((res.data && res.data.resultMsg) || '삭제하지 못했습니다.'); return; }
                if (this.editingKey == n.key) this.editingKey = null;
                this.notes = this.notes.filter(x => x.key != n.key);
            }).catch(() => alert('삭제 중 오류가 발생했습니다.'));
        },
        flash(n) {
            this.flashKey = n.key;
            setTimeout(() => { if (this.flashKey == n.key) this.flashKey = null; }, 1200);
        },
        scrollEnd() {
            this.$nextTick(() => { const s = this.$refs.stack; if (s) s.scrollTop = s.scrollHeight; });
        },
        nowText() {
            const d = new Date(), p = (x) => String(x).padStart(2, '0');
            return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds());
        },
        when(n) {
            const d = n.reg_date || '';
            const today = this.nowText().substring(0, 10);
            return d.substring(0, 10) == today ? '오늘 ' + d.substring(11, 16) : d.substring(2, 10).replace(/-/g, '.');
        },
        goAnimal(n) { if (n.notify_number) this.$router.push({ path: '/animal', query: { notify: n.notify_number } }); },
        goRequest(n) { if (n.request_idx) this.$router.push({ path: '/adoption', query: { request: n.request_idx } }); },
    },
};
</script>

<style scoped>
    /* 메모 버튼(오른쪽 아래) 바로 위에 포스트잇 더미 */
    .smp {
        /* 평소엔 창(모달 1000) 아래에 깔려 있다가, 누르거나 쓰는 중(.active)이면 위로 */
        position: fixed; right: 5rem; bottom: calc(5rem + 54px + 12px + 54px + 10px); z-index: 990;
        /* 위쪽 헤더(약 80px)를 가리지 않게 */
        width: 290px; max-height: calc(100vh - (5rem + 54px + 12px + 54px + 10px) - 90px);
        display: flex; flex-direction: column; align-items: stretch; text-align: left;
        pointer-events: none;
    }
    .smp.active { z-index: 1040; }
    .smp.smp-collapsed { max-height: none; }
    .smp-bar.smp-bar-collapsed { cursor: pointer; margin-bottom: 0; }
    .smp-bar.smp-bar-collapsed:hover { background: #FFF8DC; }
    .smp-bar-collapsed .smp-bar-btn { display: inline-flex; align-items: center; justify-content: center; }
    .smp > * { pointer-events: auto; }
    .smp-bar {
        align-self: flex-end; display: inline-flex; align-items: center; gap: 6px; margin-bottom: 6px;
        background: rgba(255, 255, 255, 0.96); border: 1px solid #F1E2B3; border-radius: 16px; padding: 3px 4px 3px 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    }
    .smp-bar-title { font-size: 13px; font-weight: 800; color: #6a5200; display: inline-flex; align-items: center; gap: 5px; }
    .smp-bar-title i { color: #E0A800; }
    .smp-bar-title small { font-size: 11.5px; color: #a08830; }
    .smp-shelter { width: auto; max-width: 130px; font-size: 12px !important; padding-top: 1px; padding-bottom: 1px; }
    .smp-bar-btn { border: none; background: none; width: 26px; height: 26px; border-radius: 50%; color: #8a7a40; padding: 0; }
    .smp-bar-btn:hover { background: rgba(0, 0, 0, 0.06); }

    .smp-stack { overflow-y: auto; overflow-x: hidden; display: flex; flex-direction: column; gap: 12px; padding: 8px 8px 10px; scrollbar-width: thin; }
    .smp-hint { align-self: flex-end; background: #fff; border-radius: 10px; padding: 8px 12px; font-size: 12.5px !important; color: #8a7a40 !important; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12); margin: 0 !important; }

    /* 포스트잇 */
    .pit {
        --bg: #FFF3A6; --edge: #F2DE6A;
        position: relative; flex-shrink: 0; min-height: 150px; padding: 14px 14px 8px;
        background: var(--bg); border-bottom-right-radius: 14px 10px;
        transform: rotate(var(--tilt)); transition: transform .15s;
        cursor: text;
    }
    .pit::before { content: ''; position: absolute; left: 0; right: 0; top: 0; height: 8px; background: var(--edge); opacity: .55; }
    .pit.c-orange { --bg: #FFD8A8; --edge: #F6B26B; }
    .pit.c-green { --bg: #CFEFD2; --edge: #95D39C; }
    .pit.c-blue { --bg: #CFE3FA; --edge: #8DB8EC; }
    .pit.c-pink { --bg: #FBD3E0; --edge: #F09AB7; }
    .pit:hover { transform: rotate(0deg) translateY(-1px); }
    .pit.editing, .pit.picking { transform: rotate(0deg); z-index: 2; }
    .pit.fresh { animation: pit-pop .5s ease-out; }
    @keyframes pit-pop { 0% { transform: scale(.94); } 60% { transform: scale(1.03); } 100% { transform: scale(1); } }
    .pit-pin { position: absolute; top: -8px; left: 50%; transform: translateX(-50%) rotate(-10deg); color: #f6951c; font-size: 18px; text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); }

    .pit-tools { display: flex; justify-content: flex-end; gap: 3px; margin: -6px -6px 4px 0; opacity: .5; transition: opacity .15s; }
    .pit:hover .pit-tools, .pit.editing .pit-tools { opacity: 1; }
    /* 편집 중: 고정·색·삭제는 숨기고 그 줄에 서식 도구 */
    .pit.editing :deep(.ql-toolbar.ql-snow) { min-height: 26px; display: flex; align-items: center; flex-wrap: nowrap; }
    .pit.editing :deep(.ql-toolbar.ql-snow .ql-formats) { margin-right: 1px !important; display: inline-flex; }
    .pit.editing :deep(.ql-toolbar.ql-snow button), .pit.editing :deep(.ql-toolbar.ql-snow .ql-picker) { width: 20px !important; height: 22px !important; padding: 3px 2px !important; margin: 0 !important; flex-shrink: 0; }
    .pit.editing :deep(.ql-toolbar.ql-snow .ql-picker-label svg), .pit.editing :deep(.ql-toolbar.ql-snow button svg) { width: 15px; height: 15px; }
    .pit.editing :deep(.rte) { margin-top: -6px; }
    .pit-tools button { border: none; background: rgba(255, 255, 255, 0.55); width: 30px; height: 30px; border-radius: 8px; padding: 0; font-size: 15px; color: #6a5a30; display: inline-flex; align-items: center; justify-content: center; }
    .pit-tools button:hover { background: #fff; color: #333; }
    .pit-tools button.on { color: #f6951c; }
    .pit-tools button:disabled { opacity: .35; }

    .pit-text { min-height: 106px; }
    .pit .pit-text, .pit .pit-text :deep(p), .pit .pit-text :deep(li) { font-size: 14px !important; color: #3a3000 !important; line-height: 1.55; }
    .pit .pit-text.empty { color: #a99a6a !important; }
    
    .pit :deep(.ql-editor p), .pit :deep(.ql-editor li) { color: #3a3000 !important; }

    .pit-foot { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 6px; margin-top: 8px; cursor: default; }
    /* 맨 아래 줄: 연결(칩·버튼) ……… 날짜 또는 [저장] */
    .pit-links { flex: 1; min-width: 0; display: flex; flex-wrap: wrap; gap: 4px; margin-left: -6px; }
    .pit-chip { display: inline-flex; align-items: center; gap: 3px; background: rgba(255, 255, 255, 0.65); border-radius: 10px; padding: 0 4px 0 8px; font-size: 11.5px; font-weight: 700; color: #6a5a20; line-height: 20px; max-width: 190px; cursor: pointer; }
    .pit-chip:hover { background: #fff; color: #f6951c; }
    .pit-chip-x { font-size: 14px; color: #8a7a40; border-radius: 50%; }
    .pit-chip-x:hover { color: #E53935; }
    .pit-link-btn { border: 1px dashed rgba(106, 90, 32, 0.45); background: rgba(255, 255, 255, 0.35); border-radius: 10px; padding: 0 8px 0 4px; font-size: 11.5px !important; font-weight: 700; color: #6a5a20; line-height: 18px; }
    .pit-link-btn i { margin-right: -1px; }
    .pit-link-btn:hover { background: #fff; color: #f6951c; border-color: #f6951c; }
    .pit-date { margin-left: auto; font-size: 11px; color: rgba(60, 48, 0, 0.55); }
    .pit-save { margin-left: auto; border: none; background: #39A966; color: #fff; font-size: 12.5px !important; font-weight: 800; border-radius: 8px; padding: 0 14px; height: 30px; }
    .pit-save:hover { background: #2E9256; }
    .pit-save:disabled { opacity: .6; }

    /* 연결 고르기 */
    .pit-pick { margin-top: 8px; background: #fff; border-radius: 10px; padding: 8px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12); cursor: default; }
    .pit-pick-tabs { display: flex; align-items: center; gap: 4px; margin-bottom: 6px; }
    .pit-pick-tabs button { border: none; background: #f2f2f2; border-radius: 8px; padding: 2px 10px; font-size: 12px !important; font-weight: 700; color: #777; }
    .pit-pick-tabs button.on { background: #FFD54F; color: #4a3800; }
    .pit-pick-tabs .pit-pick-x { margin-left: auto; background: none; padding: 2px 6px; }
    .pit-pick .pit-pick-input { font-size: 13px !important; }
    .pit-pick-list { max-height: 200px; overflow-y: auto; margin-top: 6px; display: flex; flex-direction: column; gap: 2px; }
    .pit-pick-row { border: none; background: none; text-align: left; padding: 5px 6px; border-radius: 6px; display: flex; flex-direction: column; }
    .pit-pick-row:hover { background: #FFF6D6; }
    .pit-pick-row.now { background: #FFF3C4; }
    .pit-pick-main { font-size: 12.5px; font-weight: 700; color: #333; }
    .pit-pick-sub { font-size: 11px; color: #999; }
    .pit-pick-empty { font-size: 12px !important; color: #aaa !important; text-align: center !important; margin: 8px 0 !important; }

    @media (max-width: 768px) {
        .smp { left: 12px; right: 12px; width: auto; bottom: calc(1.2rem + 36px + 10px + 40px + 8px); max-height: calc(100dvh - (1.2rem + 36px + 10px + 40px + 8px) - 80px); }
        .pit-tools { opacity: .8; }
        .pit-tools button { width: 36px; height: 34px; font-size: 16px; }
        .pit.editing :deep(.ql-toolbar.ql-snow button), .pit.editing :deep(.ql-toolbar.ql-snow .ql-picker) { width: 26px !important; height: 26px !important; }
        .smp-bar-btn { width: 34px; height: 34px; }
        .pit-link-btn, .pit-chip { line-height: 28px; }
        .pit-pick-row { padding: 9px 8px; }
        .pit .pit-pick-input { font-size: 16px !important; }
    }
</style>
